// extracted by mini-css-extract-plugin
export default {"date":"html_date__6J7Dw","input":"html_input__VdU6H"};